import { creatorStoryManual } from './rules/creatorStoryManual';
import { PostData, RulesNameInfoBox, RulesNameInfoBoxValues } from './types';
import { videoUnder3Sec } from './rules/videoUnder3Sec';
import { directVideoOver15Mins } from './rules/directVideoOver15Mins';
import { directVideoOver15MinsWide } from './rules/directVideoOver15MinsWide';
import { directVideoOver15MinsTall } from './rules/directVideoOver15MinsTall';
import { forceReminder } from './rules/forceReminder';
import { manualVideoOver15MinsA } from './rules/manualVideoOver15MinsA';
import { manualVideoOver15MinsB } from './rules/manualVideoOver15MinsB';
import { videoStoryOver60Sec } from './rules/videoStoryOver60Sec';
import { tallFeedImage } from './rules/tallFeedImage';
import { wideFeedImage } from './rules/wideFeedImage';
import { directStoryNoCaptions } from './rules/directStoryNoCaptions';
import { cropDirectImageStoryWide } from './rules/cropDirectImageStoryWide';
import { cropDirectImageStoryTall } from './rules/cropDirectImageStoryTall';
import { cropDirectImageStoryMidTall } from './rules/cropDirectImageStoryMidTall';
import { cropDirectVideoStoryWide } from './rules/cropDirectVideoStoryWide';
import { cropDirectVideoStoryTall } from './rules/cropDirectVideoStoryTall';
import { cropDirectVideoStoryMidTall } from './rules/cropDirectVideoStoryMidTall';
import { manualStoryA } from './rules/manualStoryA';
import { manualStoryB } from './rules/manualStoryB';
import { tallFeedVideo } from './rules/tallFeedVideo';
import { wideManualFeedVideoA } from './rules/wideManualFeedVideoA';
import { wideManualFeedVideoB } from './rules/wideManualFeedVideoB';
import { MultiImageStoryManual } from './rules/MultiImageStoryManual';
import { MultiImageFeedCrop } from './rules/MultiImageFeedCrop';
import { EnableDirectPublishNoMobile } from './rules/EnableDirectPublishNoMobile';
import { EnableDirectPublishHaveMobile } from './rules/EnableDirectPublishHaveMobile';
import { DirectAndMobileReminder } from './rules/DirectAndMobileReminder';
import { DirectAndEmailReminder } from './rules/DirectAndEmailReminder';

const allRules: AllRulesType = {
  creatorStoryManual,
  cropDirectImageStoryMidTall,
  cropDirectImageStoryTall,
  cropDirectImageStoryWide,
  cropDirectVideoStoryMidTall,
  cropDirectVideoStoryTall,
  cropDirectVideoStoryWide,
  DirectAndEmailReminder,
  DirectAndMobileReminder,
  directStoryNoCaptions,
  directVideoOver15Mins,
  directVideoOver15MinsTall,
  directVideoOver15MinsWide,
  EnableDirectPublishHaveMobile,
  EnableDirectPublishNoMobile,
  forceReminder,
  manualStoryA,
  manualStoryB,
  manualVideoOver15MinsA,
  manualVideoOver15MinsB,
  MultiImageFeedCrop,
  MultiImageStoryManual,
  tallFeedImage,
  tallFeedVideo,
  videoStoryOver60Sec,
  videoUnder3Sec,
  wideFeedImage,
  wideManualFeedVideoA,
  wideManualFeedVideoB
};

type AllRulesType = {
  [key in RulesNameInfoBox]: CallableFunction;
};

export const getInfoBoxErrors = (rulesToExecute: RulesNameInfoBox[], data: PostData) => {
  const filteredKeysNames = RulesNameInfoBoxValues.filter(key => rulesToExecute.includes(key));
  const initial: RulesNameInfoBox[] = [];
  return filteredKeysNames.reduce((rulesWithError, currentKey) => {
    if (allRules[currentKey](data)) {
      return [...rulesWithError, currentKey];
    }
    return rulesWithError;
  }, initial);
};
